__turbopack_context__.v({
  "embla": "styles-module-scss-module__BnYZFG__embla",
  "embla-container": "styles-module-scss-module__BnYZFG__embla-container",
  "embla__container": "styles-module-scss-module__BnYZFG__embla__container",
  "embla__slide": "styles-module-scss-module__BnYZFG__embla__slide",
  "embla__slide__inner": "styles-module-scss-module__BnYZFG__embla__slide__inner",
  "embla__viewport": "styles-module-scss-module__BnYZFG__embla__viewport",
  "is-draggable": "styles-module-scss-module__BnYZFG__is-draggable",
  "is-dragging": "styles-module-scss-module__BnYZFG__is-dragging",
  "user-title": "styles-module-scss-module__BnYZFG__user-title",
});
